import { makeStyles } from '@mui/styles';
import BackgroundWelCome from '../../../assets/icons/backgroundWelcome.png';

const useStyles = makeStyles(() => ({
  textGoogle: {
    fontSize: '10px',
    textTransform: 'none',
    lineHeight: '14px',
    fontWeight: 500,
  },
  iconGoogle: {
    fontSize: '14px',
    textTransform: 'none',
    fontWeight: 600,
    lineHeight: '21px',

  },
  textApple: {
    fontSize: '10px',
    textTransform: 'none',
    lineHeight: '14px',
    fontWeight: 500,
  },
  iconApple: {
    fontSize: '14px',
    textTransform: 'none',
    fontWeight: 600,
    lineHeight: '21px',
  },
  welcome: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  background: {
    background: `url(${BackgroundWelCome}) no-repeat`,
    backgroundSize: 'cover',
    height: '80%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  action: {
    flex: 1,
    backgroundColor: '#376BDE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  title: {
    fontSize: '40px',
    color: '#FFFFFF',
    fontWeight: 700,
    lineHeight: '60px',
  },
  actionTitle: {
    color: '#FFFFFF',
    fontSize: '21px',
    fontWeight: 700,
    marginBottom: '24px',
    textAlign: 'center',
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  disable: {
    display: 'none',
  },
  aGooogle: {
    paddingLeft: '10px',
    justifyContent: 'start',
    height: '50px',
    borderRadius: '8px',
    width: '160px',
    // '& .MuiButton-startIcon': {
    //   marginRight: '6px',
    // },
    backgroundColor: '#FFFFFF',
    // '&:hover': {
    //   bgcolor: 'rgba(255, 255, 255, 1)',
    // },
  },
}));

export default useStyles;
